import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  RouterProvider,
  createBrowserRouter,
} from "react-router-dom";
import Header from "./components/Header";
import Home from "./pages/Home";
import AboutPage from "./pages/About";
import Products from "./pages/Products";
import BlogPage from "./pages/Blogs";
import PharmaFranchise from "./pages/PharmaFranchise";
import PharmaFranchiseCompany from "./pages/PharmaFranchiseCompany";
import IndianPcdPharmaCompanies from "./pages/IndianPcdPharmaCompanies";
import PcdPharmaFranchiseCompany from "./pages/PcdPharamaFranchiseCompany";
import VisualAid from "./pages/Visual";
import Footer from "./components/Footer";
import Contact from "./pages/Contact";
import ModalContactForm from "./components/ModalContactForm";
import { Modal, Button, Placeholder } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import Root from "./Root";
import HomePage from "./pages/Home";
import VideoSlider from "./components/VideoSlider";
import SingleProduct from "./pages/SingleProduct";
import BlogDetails from "./pages/BlogDetails";
import ProductListing from "./pages/ProductListing";
import PromotionInput from "./pages/PromotionInput";
import ThirdPartyPharmaManufacturing from "./pages/ThirdPartyPharmaManufacturing";
import PcdPharmaCompanies from "./pages/PcdPharmaCompanies";
import PcdPharmaFranchise from "./pages/PcdPharmaFranchise";
import ProductPage from "./pages/ProductPage";

function App() {
  const [open, setOpen] = useState(true);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Root />,
      children: [
        {
          path: "/",
          element: <Home />,
        },
        {
          path: "/video",
          element: <VideoSlider />,
        },
        {
          path: "/company-overview",
          element: <AboutPage />,
        },
        {
          path: "/product-list",
          element: <Products />,
        },
        {
          path: "/modal-form",
          element: <ModalContactForm />,
        },
        {
          path: "/blog",
          element: <BlogPage />,
        },
        {
          path: "/:blogView/",
          element: <BlogDetails />,
        },
        {
          path: "/pharma-franchise",
          element: <PharmaFranchise />,
        },
        {
          path: "/pharma-franchise-companies",
          element: <PharmaFranchiseCompany />,
        },
        {
          path: "/pcd-pharma-franchise",
          element: <PcdPharmaFranchise />,
        },
        {
          path: "/indian-pcd-pharma-companies",
          element: <IndianPcdPharmaCompanies />,
        },
        {
          path: "/pcd-pharma-companies",
          element: <PcdPharmaCompanies />,
        },
        {
          path: "/pcd-pharma-franchise-company",
          element: <PcdPharmaFranchiseCompany />,
        },
        {
          path: "/third-party-pharma-manufacturing",
          element: <ThirdPartyPharmaManufacturing />,
        },
        {
          path: "/VisualAid",
          element: <VisualAid />,
        },
        {
          path: "/contact-us",
          element: <Contact />,
        },
        {
          path: "/Product-Listing",
          element: <ProductListing />,
        },
        {
          path: "/Promotion-Input",
          element: <PromotionInput />,
        },
        {
          path: "/categories/:id",
          element: <SingleProduct />,
        },
        {
          path: "/products/:id",
          element: <ProductPage />,
        },
      ],
    },
  ]);
  return <RouterProvider router={router} />;
}

export default App;
